export const WHITE = '#FFFFFF' // Neutral
export const GREY = '#B1BFC5' // Instructive
export const YELLOW = '#FFB800' // Gentle Warnings/Light-warning
export const RED = '#FF8064' // Urgent/Heavy-Warning
export const VIOLET = '#969BFF' // Celebratory/Caught-up/Working-ahead
export const YELLOW_MESSAGE_CARD = '#FFBB55' // Gentle Warnings/Light-warning
